import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { apiCodeSamples, apiIntegrationsList } from '../data';
import type { PlatformSubpageConfig } from '../types';

type SampleKey = keyof typeof apiCodeSamples;

export const ApisContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [active, setActive] = useState<SampleKey>('rest');
  const [copied, setCopied] = useState(false);
  const sample = apiCodeSamples[active];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(sample.code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <SiteSection className="platform-sub-interactive">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <div className="platform-apis__pills platform-sub-pills--center">
        {apiIntegrationsList.map((name) => (
          <span key={name} className="platform-apis__pill">
            {name}
          </span>
        ))}
      </div>
      <div className="platform-sub-tabs" role="tablist" aria-label="Code samples">
        {(Object.keys(apiCodeSamples) as SampleKey[]).map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active === key}
            className={`platform-sub-tabs__btn${active === key ? ' platform-sub-tabs__btn--active' : ''}`}
            onClick={() => setActive(key)}
          >
            {apiCodeSamples[key].label}
          </button>
        ))}
      </div>
      <div className="platform-code-block platform-sub-code-block">
        <div className="platform-code-block__header">
          <span className="platform-code-block__label">{sample.label}</span>
          <button type="button" className="platform-sub-copy" onClick={handleCopy}>
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
        <pre className="platform-code-block__pre">
          <code>{sample.code}</code>
        </pre>
      </div>
    </SiteSection>
  );
};
